import type { FaireProductEntity } from "../../entity_types/product";

export const p_ckylep91: FaireProductEntity = {
  token: "p_ckylep91",
  type: "product",
  name: "Thanks So Much - Mini Notecard",
  brandName: "Wrinkle & Crease Paper Products",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/0a195a56894f57922dc2a81b4c9107cb1c1761071e1c9b2f2f37fa3b7796dd20/1548197704.jpg",
  priceDollars: 1.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4bea78540b1668dbb4c693b2e06b22f605ae1627f27f45d7ca49a77124930a00.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
